import { useEffect, useRef, useState } from 'react';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErroCarregamento, { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import FiltrosPrazo from '../../components/common/FiltrosPrazo';
import TabelaPrazos from '../../components/common/TabelaPrazos';
import useFiltroVencimentos from '../../hooks/useFiltroVencimentos';
import * as avaliacoesApi from '../../api/avaliacoes';

export default function AbaVencimentos({ idHospital, onIrParaRequisito }) {
  const [avaliacoes, setAvaliacoes] = useState(null);
  const [erro, setErro] = useState('');
  const requisicaoAtual = useRef(0);

  const carregar = async () => {
    const minhaRequisicao = ++requisicaoAtual.current;
    setErro('');
    try {
      const { data } = await avaliacoesApi.listarAtuais(idHospital);
      if (requisicaoAtual.current !== minhaRequisicao) return;
      setAvaliacoes(data);
    } catch (err) {
      if (requisicaoAtual.current !== minhaRequisicao) return;
      setErro(extrairMensagemErro(err, 'Não foi possível carregar os vencimentos.'));
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idHospital]);

  const filtro = useFiltroVencimentos(avaliacoes || []);

  if (!avaliacoes) return erro ? <ErroCarregamento mensagem={erro} onRetry={carregar} /> : <LoadingSpinner />;

  return (
    <div>
      <div className="mb-3">
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--am-tinta)' }}>
          Critérios próximos do vencimento
        </div>
        <p style={{ fontSize: 13, color: 'var(--am-cinza-texto-2)', margin: '4px 0 0', maxWidth: 480 }}>
          Vigências deste hospital que vencem nos próximos {filtro.dias} dias ou já venceram.
        </p>
      </div>

      <FiltrosPrazo {...filtro} />

      <TabelaPrazos
        itens={filtro.vencimentos}
        campoData="data_vencimento_vigencia"
        colunaData="Vence em"
        vazioTexto="Nenhuma vigência encontrada com esses filtros."
        onSelecionar={onIrParaRequisito ? (v) => onIrParaRequisito(v.id_requisito) : undefined}
      />
    </div>
  );
}
